import { useImageCropContext } from '../providers/ImageCropProvider';
import {
  ArrowLeft,
  ArrowRight,
  ZoomOut,
  ZoomIn
} from '@material-ui/icons';
import classNames from 'classnames';

export const ZoomSlider = ({ className }) => {
  const { zoom, setZoom, handleZoomIn, handleZoomOut, max_zoom, min_zoom, zoom_step } =
    useImageCropContext();

  return (
    <div className={classNames(className, 'flex items-center justify-center gap-2')}>
      <button className="p-1 hidden" onClick={handleZoomOut}>
        <ZoomOut className="text-gray-400 w-4" />
      </button>
      <input
        className="full-width"
        type="range"
        name="volju"
        min={min_zoom}
        max={max_zoom}
        step={zoom_step}
        value={zoom}
        onChange={e => {
          setZoom(Number(e.target.value));
        }}
      />
      <button className="p-1 hidden" onClick={handleZoomIn}>
        <ZoomIn className="text-gray-400 w-4" />
      </button>
    </div>
  );
};

export const RotationSlider = ({ className }) => {
  const {
    rotation,
    setRotation,
    max_rotation,
    min_rotation,
    rotation_step,
    handleRotateAntiCw,
    handleRotateCw
  } = useImageCropContext();

  return (
    <div className={classNames(className, 'flex items-center justify-center gap-2')}>
      <button className="p-1 hidden" onClick={handleRotateAntiCw}>
        <ArrowLeft className="text-gray-400 w-4" />
      </button>
      <input
        type="range"
        name="volju"
        className="full-width"
        min={min_rotation}
        max={max_rotation}
        step={rotation_step}
        value={rotation}
        onChange={e => {
          setRotation(Number(e.target.value));
        }}
      />
      <button className="p-1 hidden" onClick={handleRotateCw}>
        <ArrowRight className="text-gray-400 w-4" />
      </button>
    </div>
  );
};